module.exports = __webpack_public_path__ + "static/media/dropdown.30a265cc.svg";